// extracted by mini-css-extract-plugin
export var askAiIcon = "_pv-9";
export var container = "_pv-0";
export var groupSeparator = "_pv-a";
export var highlight = "_pv-4";
export var resultIcon = "_pv-5";
export var resultItem = "_pv-7";
export var resultSubtitle = "_pv-3";
export var resultTitle = "_pv-2";
export var resultsList = "_pv-1";
export var searchGroup = "_pv-6";
export var selected = "_pv-8";